import React, {useEffect} from 'react';
import "./Hero.css";

import AOS from "aos";
import "aos/dist/aos.css";

function Hero() {

    useEffect(() => {
        AOS.init();
        AOS.refresh();
    }, []);

    return (
        <div className="Hero">
            <div className="hero-1" data-aos={"fade-up"} data-aos-delay="800">Hi, my name is</div>

            <div className="hero-2" data-aos={"fade-up"} data-aos-delay="900">Subhampreet Mohanty.</div>

            <div className="hero-3" data-aos={"fade-up"} data-aos-delay="1000">I build things for the web.</div>

            <p className="hero-subtext" data-aos={"fade-up"} data-aos-delay="1100" >Lorem ipsum dolor sit amet consectetur, adipisicing elit. Impedit, praesentium. Quasi aliquid error hic ipsum. Lorem ipsum dolor sit amet, consectetur adipisicing elit. Facilis, culpa. Lorem ipsum dolor sit amet consectetur adipisicing elit. Similique culpa dolorum neque accusamus nostrum cum</p>
            <a data-aos={"fade-up"} data-aos-delay="1300">Get In Touch</a>
        </div>
    )
}

export default Hero;